import { render, staticRenderFns } from "./topsearch.vue?vue&type=template&id=660bf30e&scoped=true"
import script from "./topsearch.vue?vue&type=script&lang=js"
export * from "./topsearch.vue?vue&type=script&lang=js"
import style0 from "./topsearch.vue?vue&type=style&index=0&id=660bf30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660bf30e",
  null
  
)

export default component.exports